<div id="arena" [ngStyle]="{ overflow: 'scroll', display: activeObjectInfo && !noLayoutPath ? 'block' : 'none' }">
  <dx-scroll-view> <ng-container #dynamic></ng-container></dx-scroll-view>
</div>

<div class="noDataPlaceHolder" [ngStyle]="{ display: noLayoutPath ? 'block' : 'none' }">
  &lt;{{ res.get('ObjectInfo-NoData') }}&gt;
</div>
